import { render, staticRenderFns } from "./createDisciplinaryType.vue?vue&type=template&id=22486afe&scoped=true"
import script from "./createDisciplinaryType.vue?vue&type=script&lang=js"
export * from "./createDisciplinaryType.vue?vue&type=script&lang=js"
import style0 from "./createDisciplinaryType.vue?vue&type=style&index=0&id=22486afe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22486afe",
  null
  
)

export default component.exports